﻿import assignDotNetReference from "./assignDotNetReference.js";
import callDotNet from "./callDotNet.js";
import callMethodOnElement from "./callMethodOnElement.js";
import triggerEvent from "./triggerEvent.js";
import updateAlpineModel from "./updateAlpineModel.js";
import updateElementHtml from "./updateElementHtml.js";

export default {
  assignDotNetReference,
  callDotNet,
  callMethodOnElement,
  triggerEvent,
  updateAlpineModel,
  updateElementHtml,
}
